<div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <div class="d-flex">
        <app-go-back></app-go-back>
        <h1 class="h2 text-info">{{ 'performances.view.title' | translate }} <span class="fs-3 text-secondary">{{ point_of_sale_name }}</span></h1>
    </div>
    <div class="btn-toolbar mb-2 mb-md-0">
        <div class="row">
        <div class="col">
            <form class="row row-cols-sm-auto">
            <div class="col-12 d-flex flex-row">
                <label class="col-sm-2 col-form-label fw-bold text-info">{{ 'performances.view.filters.fromLabel' | translate }}</label>
                <div class="input-group">
                <input ngb-dp-today [(ngModel)]="startDate" (ngModelChange)="onDateChange($event)" class="form-control"
                    placeholder="dd/mm/yyyy" name="start_date" [(ngModel)]="startDate" ngbDatepicker #d="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar bg-info" (click)="d.toggle()" type="button">
                    <i-bs name="calendar3" class="text-white"></i-bs>
                </button>
                </div>
            </div>
            </form>
        </div>
        <div class="col">
            <form class="row row-cols-sm-auto">
            <div class="col-12 d-flex flex-row">
                <label class="col-sm-2 col-form-label fw-bold text-info">{{ 'performances.view.filters.toLabel' | translate }}</label>
                <div class="input-group">
                <input ngb-dp-today [(ngModel)]="endDate" (ngModelChange)="onDateChange($event)" class="form-control"
                    placeholder="dd/mm/yyyy" name="end_date" [(ngModel)]="endDate" ngbDatepicker #e="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar bg-info" (click)="e.toggle()" type="button">
                    <i-bs name="calendar3" class="text-white"></i-bs>
                </button>
                </div>
            </div>
            </form>
        </div>
        </div>
    </div>
    </div>
</div>
<div *ngIf="loading" class="d-flex justify-content-center">
    <div class="spinner-border mx-auto mt-5 text-success" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
    </div>
</div>
<table  *ngIf="loaded" class="table align-middle table-hover">
    <thead class="table-light">
      <tr class="rounded">
        <th scope="col">{{ 'performances.view.table.columns.sku' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.view.table.columns.finalStock' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.view.table.columns.initialStock' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.view.table.columns.rotation' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.view.table.columns.purchaseOrder' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.view.table.columns.downgraded' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.view.table.columns.downgradedAmount' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let performance of this.performances">
        <th scope="row"class="fw-bold text-info">
          {{ performance.sku_sage }}
        </th>
        <td class="text-center text-primary fw-bold">
          <span>
            {{  performance.sp_final_stock }}
          </span>
        </td>
        <td class="text-center text-primary fw-bold">
            <span>
              {{  performance.is_quantity }}
            </span>
          </td>
        <td class="text-center text-primary fw-bold">
          <span>
            {{ performance.sp_rotation }}
          </span>
        </td>
        <td class="text-center text-primary fw-bold">
          <span>
            {{ performance.op_quantity }}
          </span>
        </td>
        <td class="text-center text-primary fw-bold">
            <span>
              {{ performance.rp_quantity }} 
            </span>
        </td>
        <td class="text-center text-primary fw-bold">
            <span>
              {{ performance.rp_amount | currency:'XOF':'symbol-narrow':'1.O-2' }}
            </span>
        </td>
      </tr>
    </tbody>
  </table>
